import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import GlassCard from "../../components/ui-custom/GlassCard";
import Reveal from "../../components/ui-custom/Reveal";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
const API = `${BACKEND_URL}/api`;

const formatDate = (value) => {
  if (!value) return "";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" });
};

const StoryDetail = () => {
  const { storyId } = useParams();
  const [story, setStory] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    axios
      .get(`${API}/employees/stories/${storyId}`, { withCredentials: true })
      .then((res) => setStory(res.data))
      .catch(() => setFailed(true));
  }, [storyId]);

  return (
    <div className="max-w-3xl">
      <Link to="/employees/stories" className="text-sm text-qcyan hover:underline inline-flex items-center gap-1.5 mb-6">
        <ArrowLeft size={14} /> Back to Stories
      </Link>

      {failed && <p className="text-sm text-muted-foreground">This story could not be found.</p>}
      {!failed && !story && <p className="text-sm text-muted-foreground">Loading…</p>}

      {story && (
        <Reveal>
          <GlassCard className="p-8">
            {story.category && (
              <span className="text-xs font-semibold text-qcyan uppercase tracking-wide">{story.category}</span>
            )}
            <h1 className="font-display font-semibold text-3xl text-foreground mt-2 mb-3">{story.title}</h1>
            <p className="text-xs text-muted-foreground mb-6">
              {story.author_name} · {formatDate(story.created_at)}
            </p>
            <div className="text-sm text-foreground leading-relaxed whitespace-pre-wrap">{story.body}</div>
          </GlassCard>
        </Reveal>
      )}
    </div>
  );
};

export default StoryDetail;
